
  var _styles = {};



  module.exports = _styles;
  